import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint, withCredentials: true });
    const gcclient = createRestApiClient().withConfig({ baseURL: 'https://app.growth-connections.com' });
    return {
        createInvoices: (filter) => client.request({
            method: 'POST',
            url: '/shopify/invoices',
            data: filter
        }),
        setCustomerInvoiceExclusion: (customerId, excluded) => client.request({
            method: 'POST',
            url: '/shopify/customers/invoice-exclusion',
            data: { customerId, excluded }
        }),
        updateInvoice: (invoice) => client.request({
            method: 'PUT',
            url: '/shopify/invoices',
            data: invoice
        }),
        stornoInvoices: (filter) => client.request({
            method: 'POST',
            url: '/shopify/invoices/storno',
            data: filter
        }), 
        markOrdersAsPaid: (orders) => client.request({
            method: 'POST',
            url: '/shopify/orders/markaspaid',
            data: orders
        }),
        fulfillOrder: (order) => client.request({
            method: 'POST',
            url: '/shopify/orders/fulfill',
            data: order
        }),
        updateOrder: (order) => client.request({
            method: 'PUT',
            url: '/shopify/orders',
            data: order
        }),
        cancelAllFullfillments: (order) => client.request({
            method: 'POST',
            url: '/shopify/orders/fulfill/cancel',
            data: order
        }),
        getOrders: (filter) => client.request({
            method: 'POST',
            url: '/shopify/orders',
            data: filter
        }),
        exportOrders: (filter) => client.request({
            method: 'POST',
            url: '/shopify/orders/export',
            data: filter
        }),        
        getProducts: () => client.request({
            method: 'GET',
            url: '/shopify/products'
        }),
        getCollections: () => client.request({
            method: 'GET',
            url: '/shopify/collections'
        }),
        getCampaigns: (owner) => gcclient.request({
            method: 'GET',
            url: `campaign/interop/shopify?owner=${owner}`
        }),
        getLocations: (download)=> client.request({
            method: 'GET',
            url: `/shopify/locations?download=${download? true: false}`
        }),
        addLocation: (location)=> client.request({
            method: 'POST',
            url: '/shopify/locations',
            data: location
        }), 
        
        printGlsLabel: (request)=> client.request({
            method: 'POST',
            url: '/shopify/label/gls',
            data:request
        }),
        deliverInvoice: (data)=> client.request({
            method: 'POST',
            url: '/shopify/orders/deliver',
            data
        }),
        deliveryFailures: (data) => client.request({
            method: 'POST',
            url: '/shopify/orders/delivery-failures',
            data
        }),
        redeliverFailures: () => client.request({
            method: 'POST',
            url: '/shopify/orders/redeliver-failures',
            data: {}
        })

    };
};


// WEBPACK FOOTER //
// app/services/shopify.js